import React from "react";
import { PropTypes } from "prop-types";
import InfoTooltip from "../../../react_utils/InfoTooltip";
import {
  getLoadHistoryTitle,
  getProductionHistoryTitle,
} from "../../../shared/utils/flowhistoryutils";

export function LoadHistoryTitle({ timeHorizon }) {
  const loadHistoryTitle = getLoadHistoryTitle(timeHorizon);
  return (
    <>
      {loadHistoryTitle.title}{" "}
      <InfoTooltip>{loadHistoryTitle.help}</InfoTooltip>
    </>
  );
}

LoadHistoryTitle.propTypes = {
  timeHorizon: PropTypes.oneOf(["hourly", "daily", "monthly"]),
};

export function ProductionHistoryTitle({ timeHorizon }) {
  const productionHistoryTitle = getProductionHistoryTitle(timeHorizon);
  return (
    <>
      {productionHistoryTitle.title}{" "}
      <InfoTooltip>{productionHistoryTitle.help}</InfoTooltip>
    </>
  );
}

ProductionHistoryTitle.propTypes = {
  timeHorizon: PropTypes.oneOf(["hourly", "daily", "monthly"]),
};
